import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { ClientConfigStore } from '@shared/data';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ApiUrlInterceptor implements HttpInterceptor {
  private clientConfigStore = inject(ClientConfigStore);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.clientConfigStore.loaded() && req.url.startsWith('/api')) {
      const apiReq = req.clone({
        url: this.clientConfigStore.config().apiUrl + req.url
      });

      return next.handle(apiReq);
    }

    return next.handle(req);
  }
}
